//---- Automatically generated, don't update this part ----

import Transform from "@ember-data/serializer/transform";
import Specialty from "parog-web/models/specialty";

export default class SpecialtyTransform extends Transform {
  override deserialize(serialized) {
    if (serialized) {
      return new Specialty(serialized);
    }

    return null;
  }

  override serialize(deserialized) {
    return deserialized?.toJson();
  }
  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/transform" {
  export default interface ModelRegistry {
    specialty: SpecialtyTransform;
  }
}
